import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "tab_content",
  "element-loading-background": "transparent"
}
const _hoisted_2 = { class: "tab_cont" }
const _hoisted_3 = { class: "num" }
const _hoisted_4 = { class: "sq_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "sign" }
const _hoisted_7 = { class: "li_tit" }
const _hoisted_8 = { class: "li_ms" }
const _hoisted_9 = { key: 0 }

import { reactive } from "vue";
import { useRouter } from "vue-router"
import { getOneThingItemList } from "@/config/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()

const toPath = (item:any) => {
    router.push({
        path:'./selection-situation',
        query: {
            modelCode:item.modelCode,
            modelName:item.modelName,
            parentid:item.parentid,
            theme:item.theme,
            hangyeType_dictText:item.hangyeType_dictText
        }
    })
}

const data = reactive({
    itemList:[] as any,
    total: 0,
    loading: true,
})

const getItemListData = async() => {
    let res = await getOneThingItemList({
        userType:'',          //  自然人和法人 法人
        areaCode:'410296000000',
        pageNo:'1',
        pageSize:'300',
        theme:'!承诺制',
    }) as any
    data.loading = false
    if(res.code === 200){
        data.itemList = res.result?.records
        data.total = res.result?.total
    }

}
getItemListData()



return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
      _createElementVNode("span", null, "首页"),
      _createTextVNode(),
      _createElementVNode("i", null, ">"),
      _createTextVNode(),
      _createElementVNode("span", null, "一件事")
    ], -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, "共 " + _toDisplayString(data.total) + " 条数据", 1),
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.itemList, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.unid,
              onClick: ($event: any) => (toPath(item))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, _toDisplayString(item.userType), 1)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.modelName), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, "主办单位：" + _toDisplayString(item.leadDept), 1),
                _createElementVNode("span", null, "事项类型：" + _toDisplayString(item.onetingType), 1),
                _createElementVNode("span", null, "联办单位：" + _toDisplayString(item.jointDapt), 1)
              ])
            ], 8, _hoisted_5))
          }), 128))
        ]),
        (data.itemList.length === 0 && data.loading === false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, data.loading]
    ])
  ]))
}
}

})